import script from "./SnsRecoveryGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./SnsRecoveryGuide.vue?vue&type=script&setup=true&lang=js"

import "./SnsRecoveryGuide.vue?vue&type=style&index=0&id=2bf24df1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf24df1"]])

export default __exports__